import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DashboardWrap from '../../components/DashboardWrap';
import GoBackIcon from '../../svgs/GoBackIcon';
import Styles from './RewardDetails.module.scss';
import RewardDetailsCard from './RewardDetailsCard';
import RewardDetailsTableRecord from './RewardDetailsTableRecord';

const RewardDetails = () => {
  const { push } = useHistory();
  const { userId } = useParams<{ userId: string }>();
  const [referralId, setReferralId] = useState(null);
  return (
    <DashboardWrap>
      <div className={Styles.wrapper}>
        <div className={Styles.wrapper__title}>
          <span>
            <GoBackIcon onClick={() => push('/rewards?page=1')} />
            Referral details
          </span>

        </div>
        <RewardDetailsCard rewardId={userId} setReferralId={(data) => setReferralId(data)} />
        <RewardDetailsTableRecord referralId={referralId} />
      </div>
    </DashboardWrap>
  );
};

export default RewardDetails;
